// Single source of truth for the auction-sheet extraction shape.
// Keep in sync with `app/Prompts/AuctionSheetPrompt.php::schema()` (aurobil-lara).
// Mirrors the "Vehicle Details" DB-aligned sections (vehicle_stocks + vs_* lookups).

export const AUCTION_SHEET_SECTIONS = [
  {
    title: "Specifications",
    fields: [
      { key: "brand", label: "Brand" },
      { key: "model", label: "Model" },
      { key: "year", label: "Year" },
      { key: "package", label: "Package" },
      { key: "exterior_color", label: "Color" },
      { key: "interior_color", label: "Interior Color" },
      { key: "mileage_km", label: "Mileage (KM)", type: "number" },
      { key: "doors", label: "Doors", type: "number" },
      { key: "seats", label: "Seats", type: "number" },
      { key: "tire_size", label: "Tire Size" },
      { key: "location", label: "Location" },
    ],
  },
  {
    title: "Technical Details",
    fields: [
      { key: "engine_cc", label: "Engine (CC)" },
      { key: "chassis_code", label: "Chassis Code" },
      { key: "engine_code", label: "Engine Code" },
      { key: "fuel_type", label: "Fuel Type" },
      { key: "engine_type", label: "Engine Type" },
      { key: "key_type", label: "Key Type" },
      { key: "auction_grade", label: "Auction Grade" },
      { key: "transmission", label: "Transmission" },
    ],
  },
  {
    title: "Identification",
    fields: [{ key: "chassis_no", label: "Chassis Number" }],
  },
]

export const AUCTION_SHEET_FIELDS = AUCTION_SHEET_SECTIONS.reduce(
  (fields, section) => fields.concat(section.fields),
  []
)

export const parseAuctionSheetJson = raw => {
  if (!raw) return null

  try {
    const cleaned = raw.replace(/^```(?:json)?\s*/i, "").replace(/\s*```$/, "")
    const value = JSON.parse(cleaned)
    return value && typeof value === "object" && !Array.isArray(value)
      ? value
      : null
  } catch {
    return null
  }
}

export const getExtractedShortDescription = data => {
  if (!data) return ""

  if (data.short_description) return data.short_description

  return (data.features || []).join(", ")
}